/** Shared safety ceiling for authored questions in every call-enabled plan. */
export const CALL_QUESTION_LIMIT = 20;

/** Counts answer-bearing fields, including optional and historical reaction fields. */
export function countAuthoredCallQuestions(fields: unknown): number {
  if (!Array.isArray(fields)) return 0;
  return fields.filter((field: unknown) => {
    if (!field || typeof field !== 'object') return false;
    const question = field as Record<string, unknown>;
    return question.type !== 'information' || question.responseMode !== 'passive';
  }).length;
}

/** Actionable creator validation, independent of commercial plan or probing turns. */
export function getCallQuestionLimitIssue(fields: unknown, callsEnabled: boolean): { reason: 'call_question_limit_exceeded'; message: string } | null {
  if (!callsEnabled || countAuthoredCallQuestions(fields) <= CALL_QUESTION_LIMIT) return null;
  return { reason: 'call_question_limit_exceeded', message: 'Use at most 20 questions for calls, or turn calls off.' };
}
